import React, { useState } from 'react';
import { Plane, Building2, User, CheckCircle, ArrowRight, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
export function RegisterPage() {
  const [step, setStep] = useState(1);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (step < 3) {
      setStep(step + 1);
    } else {
      setIsSuccess(true);
    }
  };
  if (isSuccess) {
    return <div className="min-h-screen w-full flex items-center justify-center bg-slate-900 relative overflow-hidden" data-id="element-1130">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-1131"></div>
        <div className="relative w-full max-w-md p-6 text-center" data-id="element-1132">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-500" data-id="element-1133">
            <CheckCircle className="h-10 w-10" data-id="element-1134" />
          </div>
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-1135">
            Account Created!
          </h2>
          <p className="text-slate-400 mb-8" data-id="element-1136">
            We've sent a verification email to your inbox. Please click the link
            to verify your account and start setting up your organization.
          </p>
          <Link to="/login" className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-8 py-3 text-sm font-medium text-white hover:bg-blue-700 transition-colors" data-id="element-1137">
            Return to Login
          </Link>
        </div>
      </div>;
  }
  return <div className="min-h-screen w-full flex items-center justify-center bg-slate-900 relative overflow-hidden" data-id="element-1138">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-1139"></div>

      <div className="relative w-full max-w-lg p-6" data-id="element-1140">
        <div className="mb-8 text-center" data-id="element-1141">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-blue-600 text-white" data-id="element-1142">
            <Plane className="h-6 w-6" data-id="element-1143" />
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-1144">
            Create Organization Account
          </h1>
          <p className="mt-2 text-slate-400" data-id="element-1145">Step {step} of 3</p>
        </div>

        <div className="rounded-2xl bg-white p-8 shadow-2xl" data-id="element-1146">
          {/* Progress Steps */}
          <div className="flex items-center justify-between mb-8 relative" data-id="element-1147">
            <div className="absolute left-0 top-1/2 h-0.5 w-full -translate-y-1/2 bg-slate-100 -z-10" data-id="element-1148"></div>
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors ${step >= 1 ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-400'}`} data-id="element-1149">
              1
            </div>
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors ${step >= 2 ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-400'}`} data-id="element-1150">
              2
            </div>
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors ${step >= 3 ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-400'}`} data-id="element-1151">
              3
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1152">
            {step === 1 && <div className="space-y-4 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-1153">
                <div className="text-center mb-6" data-id="element-1154">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-1155">
                    Organization Details
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-1156">
                    Tell us about your company
                  </p>
                </div>

                <div data-id="element-1157">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1158">
                    Company Name
                  </label>
                  <div className="relative" data-id="element-1159">
                    <Building2 className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-1160" />
                    <input type="text" required className="block w-full rounded-lg border border-slate-300 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="Acme Corp" data-id="element-1161" />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-1162">
                  <div data-id="element-1163">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1164">
                      Industry
                    </label>
                    <select className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-1165">
                      <option data-id="element-1166">Technology</option>
                      <option data-id="element-1167">Finance</option>
                      <option data-id="element-1168">Healthcare</option>
                      <option data-id="element-1169">Manufacturing</option>
                      <option data-id="element-1170">Retail</option>
                    </select>
                  </div>
                  <div data-id="element-1171">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1172">
                      Company Size
                    </label>
                    <select className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-1173">
                      <option data-id="element-1174">1-10</option>
                      <option data-id="element-1175">11-50</option>
                      <option data-id="element-1176">51-200</option>
                      <option data-id="element-1177">201-500</option>
                      <option data-id="element-1178">500+</option>
                    </select>
                  </div>
                </div>

                <div data-id="element-1179">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1180">
                    Headquarters Country
                  </label>
                  <select className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-1181">
                    <option data-id="element-1182">United States</option>
                    <option data-id="element-1183">United Kingdom</option>
                    <option data-id="element-1184">Canada</option>
                    <option data-id="element-1185">Germany</option>
                    <option data-id="element-1186">France</option>
                    <option data-id="element-1187">Japan</option>
                  </select>
                </div>
              </div>}

            {step === 2 && <div className="space-y-4 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-1188">
                <div className="text-center mb-6" data-id="element-1189">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-1190">
                    Admin Account
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-1191">
                    Create your administrator profile
                  </p>
                </div>

                <div data-id="element-1192">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1193">
                    Full Name
                  </label>
                  <div className="relative" data-id="element-1194">
                    <User className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-1195" />
                    <input type="text" required className="block w-full rounded-lg border border-slate-300 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="John Doe" data-id="element-1196" />
                  </div>
                </div>

                <div data-id="element-1197">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1198">
                    Work Email
                  </label>
                  <input type="email" required className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="john@company.com" data-id="element-1199" />
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-1200">
                  <div data-id="element-1201">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1202">
                      Password
                    </label>
                    <input type="password" required className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="••••••••" data-id="element-1203" />
                  </div>
                  <div data-id="element-1204">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1205">
                      Confirm
                    </label>
                    <input type="password" required className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="••••••••" data-id="element-1206" />
                  </div>
                </div>
              </div>}

            {step === 3 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-1207">
                <div className="text-center mb-6" data-id="element-1208">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-1209">
                    Review & Submit
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-1210">
                    Please verify your information
                  </p>
                </div>

                <div className="rounded-lg bg-slate-50 p-4 space-y-3 text-sm" data-id="element-1211">
                  <div className="flex justify-between border-b border-slate-200 pb-2" data-id="element-1212">
                    <span className="text-slate-500" data-id="element-1213">Company</span>
                    <span className="font-medium text-slate-900" data-id="element-1214">
                      Acme Corp
                    </span>
                  </div>
                  <div className="flex justify-between border-b border-slate-200 pb-2" data-id="element-1215">
                    <span className="text-slate-500" data-id="element-1216">Industry</span>
                    <span className="font-medium text-slate-900" data-id="element-1217">
                      Technology
                    </span>
                  </div>
                  <div className="flex justify-between border-b border-slate-200 pb-2" data-id="element-1218">
                    <span className="text-slate-500" data-id="element-1219">Admin</span>
                    <span className="font-medium text-slate-900" data-id="element-1220">John Doe</span>
                  </div>
                  <div className="flex justify-between" data-id="element-1221">
                    <span className="text-slate-500" data-id="element-1222">Email</span>
                    <span className="font-medium text-slate-900" data-id="element-1223">
                      john@acme.com
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-2" data-id="element-1224">
                  <input type="checkbox" required className="mt-1 h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500" data-id="element-1225" />
                  <label className="text-sm text-slate-600" data-id="element-1226">
                    I agree to the{' '}
                    <a href="#" className="text-blue-600 hover:underline" data-id="element-1227">
                      Terms of Service
                    </a>{' '}
                    and{' '}
                    <a href="#" className="text-blue-600 hover:underline" data-id="element-1228">
                      Privacy Policy
                    </a>
                  </label>
                </div>
              </div>}

            <div className="flex gap-3 pt-4" data-id="element-1229">
              {step > 1 && <button type="button" onClick={() => setStep(step - 1)} className="flex items-center justify-center rounded-lg border border-slate-300 bg-white px-5 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-1230">
                  <ArrowLeft className="mr-2 h-4 w-4" data-id="element-1231" /> Back
                </button>}
              <button type="submit" className="flex flex-1 items-center justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-700" data-id="element-1232">
                {step === 3 ? 'Create Account' : 'Next Step'}
                {step < 3 && <ArrowRight className="ml-2 h-4 w-4" data-id="element-1233" />}
              </button>
            </div>
          </form>
        </div>

        <p className="mt-6 text-center text-sm text-slate-500" data-id="element-1234">
          Already have an account?{' '}
          <Link to="/login" className="font-medium text-blue-400 hover:underline" data-id="element-1235">
            Sign in
          </Link>
        </p>
      </div>
    </div>;
}